import { RouteObject } from "react-router";
import { CleComplianceRoutes } from "@/features/cle-compliance/routes";
import { ROUTES } from "@/constants/routes";

export const efteruddannelseRoutes: RouteObject[] = [
  {
    ...CleComplianceRoutes,
    id: ROUTES.efteruddannelse.id,
    path: "/efteruddannelse",
  },
];
